import { cleanupExpiredTodos } from './cleanupExpiredTodos';

// Admin utility to manually trigger cleanup
export const adminManualCleanup = async () => {
  try {
    const result = await cleanupExpiredTodos();
    
    if (result.success) {
      return {
        success: true,
        message: `Successfully deleted ${result.deletedCount} expired todos.`,
        deletedCount: result.deletedCount
      };
    } else {
      return {
        success: false,
        message: `Cleanup failed: ${result.error}`,
        error: result.error
      };
    }
  } catch (error) {
    return {
      success: false,
      message: `Error: ${error.message}`,
      error: error.message
    };
  }
};

// Function to get cleanup statistics
export const getCleanupStats = async () => {
  try {
    const { collection, query, where, getDocs } = await import('firebase/firestore');
    const { db } = await import('../firebase/config');
    
    const now = new Date();
    const usersSnapshot = await getDocs(collection(db, 'users'));
    let totalTodos = 0;
    let expiredTodos = 0;
    
    for (const userDoc of usersSnapshot.docs) {
      const userId = userDoc.id;
      
      // Get all todos for this user
      const todosQuery = query(collection(db, 'users', userId, 'dailyTodos'));
      const todosSnapshot = await getDocs(todosQuery);
      
      totalTodos += todosSnapshot.size;
      
      // Count expired todos
      todosSnapshot.forEach((todoDoc) => {
        const todoData = todoDoc.data();
        if (todoData.expiresAt && todoData.expiresAt.toDate() <= now) {
          expiredTodos++;
        }
      });
    }
    
    return {
      success: true,
      stats: {
        totalTodos,
        expiredTodos,
        activeTodos: totalTodos - expiredTodos
      }
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};
